import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import { FormControlLabel, FormControl, FormLabel, MenuItem, Radio, RadioGroup, Tooltip, TextField } from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";

import { NavTopMenu } from "../shared/NavTopMenu";
import { Footer } from "../shared/Footer";
import { SidebarMenu } from "../shared/SidebarMenu";

import { useTable } from "react-table";

import "../../styles/style.scss";
import { font } from "../../constants/styles/styles";

import { convertDateToJulian } from "../../constants/component/convertDateToJulian";
import { sesionExpired } from "../../constants/auth/sesionExpired";
import { timeSessionDifference } from "../../constants/auth/timeSessionDifference";
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import usersService from "../../services/users.service";
import DiscountsAndInvoicesServices from "../../services/discounts-and-invoices.services";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export const DiscountsAndInvoicesHeaderScreen = (props) => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const an8Logged = isLoggedIn ? user.noCustomer : "---";

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const redirectLoad = location.state && location.state?.reloadFilters ? location.state : null;

  const CustomRadio = withStyles({
    root: {
      color: font.baseCheckboxColor,
      "&$checked": {
        color: font.baseColor,
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

  let dateSubtract = new Date();
  dateSubtract.setMonth(dateSubtract.getMonth() - 6);

  const dateMin = dateSubtract;

  const currencySelected = "es-Mx";

  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const [customers, setCustomers] = useState({
    isLoading: true,
    isDisabled: true,
    data: [],
  });

  const [selectStartDate, handleStartDateChange] = useState(null);
  const [selectEndDate, handleEndDateChange] = useState(null);

  const [selectedStatusValue, setSelectedStatusValue] = useState("");

  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isSubmitingData, setIsSubmitingData] = useState(false);

  const [errorResponse, setErrorResponse] = useState("");
  const [isErrorResponse, setIsErrorResponse] = useState(false);

  const [dataHeader, setDataHeader] = useState([]);
  
  //Se almacena el resultado de la consulta para el Render de las celdas
  const [results, setResults] = useState([]);
  const [isDownloadFile, setIsDownloadFile] = useState(false) 
  const [dataFilters, setDataFilters] = useState({
    an8: "",
  });

  const headerRef = useRef();

  headerRef.current = dataHeader;
  
  const validationSchema = Yup.object().shape({
    an8: Yup.string().required("cliente requerido"),
    startDate: Yup.date().default(selectStartDate).required("valor requerido"),
    endDate: Yup.date()
      .default(selectEndDate)
      .required("valor requerido")
      .min(selectStartDate ? selectStartDate : dateMin),
  });

  const { control, handleSubmit, getValues, setValue, register, reset } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "total",
        Cell: ({ value }) => <b>{value}</b>,
      },
      {
        Header: "Cliente",
        accessor: "an8",
      },
      {
        Header: "Tipo",
        accessor: "discountType",
      },
      {
        Header: "Monto otorgado",
        accessor: "amountAwardedSum",
      },
      {
        Header: "Ton.",
        accessor: "ton",
      },
      {
        Header: "ID Bonificación o descuento",
        accessor: "discount",
      },
      {
        Header: "Facturas que lo originaron",
        accessor: "origin",
        Cell: (propsCells) => {
          const rowIdx = propsCells.row.id;
          const totalStatus = propsCells.row?.original?.total;

          const viewDetail = (id) => {
            const detailRow = headerRef.current[id];
            props.history.push({
              pathname: `/operation/discounts-and-invoices/detail-origin/${detailRow.discount}`,
              state: { dataHeader: detailRow },
            });
            window.location.reload();
          };

          return (
            <div className={`${totalStatus ? "d-none" : "d-block"}`}>
              <Tooltip title="Ver detalle" placement="top-start" arrow>
                <button className="btn custom-btn-icons" onClick={() => viewDetail(rowIdx)}>
                  Origen <i className="fas fa-search mr-1"></i>
                </button>
              </Tooltip>
            </div>
          );
        },
      },
      {
        Header: "Facturas en que se aplicó ",
        accessor: "aplication",
        Cell: (propsCells) => {
          const rowIdx = propsCells.row.id;
          const totalStatus = propsCells.row?.original?.total;

          const viewDetail = (id) => {
            const detailRow = headerRef.current[id];
            props.history.push({
              pathname: `/operation/discounts-and-invoices/detail-aplication/${detailRow.discount}`,
              state: { dataHeader: detailRow },
            });
            window.location.reload();
          };

          return (
            <div className={`${totalStatus ? "d-none" : "d-block"}`}>
              <Tooltip title="Ver detalle" placement="top-start" arrow>
                <button className="btn custom-btn-icons" onClick={() => viewDetail(rowIdx)}>
                  Aplicación <i className="fas fa-search mr-1"></i>
                </button>
              </Tooltip>
            </div>
          );
        },
      },
      {
        Header: "Monto por aplicar",
        accessor: "amountAwarded",
      },
      {
        Header: "Saldo Pendiente de aplicar sin IVA",
        accessor: "outstandingBalance",
      },
      {
        Header: "Fecha de emisión",
        accessor: "broadcastDate",
      },
      {
        Header: "Fecha de última aplicación",
        accessor: "lastApplicationDate",
      },
    ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataHeader]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns: columns,
    data: dataHeader,
  });

  useEffect(() => {
    getCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (redirectLoad?.reloadFilters && isFirstLoad) {
      const params = JSON.parse(localStorage.getItem("headerFilter"));
      const dataTransform = {
        ...params,
        startDate: new Date(params.startDateDefault),
        endDate: new Date(params.endDateDefault),
      };
      const res = JSON.parse(localStorage.getItem('recoverList'));
      console.log('res: ', res);
      setResults(res);
      setValue("an8", params.an8);
      setValue("startDate", new Date(params.startDate));
      setValue("endDate", new Date(params.endDate));
      setValue("balance", params.balance);
      handleStartDateChange(dataTransform.startDate);
      handleEndDateChange(dataTransform.endDate);
      setSelectedStatusValue(params.balance);
      setDataFilters(dataTransform);
      reset(dataTransform);
      setDataHeader(JSON.parse(localStorage.getItem("prevResponseFilter")));
      setIsSubmitingData(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
  const getCustomers = () => {
    setCustomers({
      isLoading: true,
      isDisabled: true,
      data: [],
    });
    usersService
      .getCustomerAssociatesByAN8(an8Logged)
      .then((response) => {
        let customersResponse = response;

        setCustomers({
          isLoading: false,
          isDisabled: false,
          data: customersResponse,
        });
      })
      .catch((error) => {
        console.error(error);
        setCustomers({
          isLoading: false,
          isDisabled: false,
          data: [""],
        });

        if (sessionDifference > Number(tokenExpired)) {
          sesionExpired(dispatch, history);
        } else {
          actionErrorConnection(error, "Error al recuperar clientes.");
        }
      });
  };

  /**
   * Cambia estado de componente
   * @param {*} event - Acción de cambio de estado
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
  const handleChangeStatus = (event) => {
    setSelectedStatusValue(event.target.value);
  };

  const handleChangeValue = (event, input) => {
    const inputValue = event.target.value;
    const arrayValue = { ...dataFilters, [input]: inputValue };

    setDataFilters(arrayValue);
    reset(arrayValue);
  };

  /**
   * Crea el onjeto a enviar en la petición de busqueda
   * @param {object} data - información del formulario
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
  const onSubmit = (data) => {
    const element = document.getElementById("collapseExample");
    element.classList.remove("show");

    setDataHeader([]);

    setIsLoadingData(true);
    setIsErrorResponse(false);

    let params = {};
    if (redirectLoad?.reloadFilters && isFirstLoad) {
      params = JSON.parse(localStorage.getItem("headerFilter"));
      setIsFirstLoad(false);
    } else {
      const startDate = selectStartDate ? selectStartDate : getValues().startDate;
      const endDate = selectEndDate ? selectEndDate : getValues().endDate;

      params = {
        an8: data.an8,
        startDate: convertDateToJulian(startDate),
        endDate: convertDateToJulian(endDate),
        balance: selectedStatusValue,
        startDateDefault: startDate,
        endDateDefault: endDate,
      };
      // console.log(params);
    }
    localStorage.removeItem("headerFilter");
    localStorage.setItem("headerFilter", JSON.stringify(params));

    getDetailHeaderByFilters(params);
  };

  /**
   * Recupera lcabecero por filtros
   * @param {object} params - filtros para la busqueda
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
  const getDetailHeaderByFilters = (params) => {
    DiscountsAndInvoicesServices.getDiscountsAndInvoicesHeader(params)
      .then((response) => {
        setIsSubmitingData(true);
        if (response.data) {
          const recoverList = response.data.discountsAndInvoicesHeaderDtoList;

          setResults(recoverList);
          console.log('store: ', recoverList);
          localStorage.setItem('recoverList', JSON.stringify(recoverList));

          let { amountAwardedSumTotal, tonTotal } = SumDetailHeader(recoverList);

          const resultArray = [
            ...recoverList,
            {
              total: "Total",
              amountAwardedSum: amountAwardedSumTotal,
              ton: tonTotal,
              amountAwarded: response.data?.totalSumOfAmountAwarded,
            },
          ];
          setDataHeader(resultArray);
          localStorage.setItem("prevResponseFilter", JSON.stringify(resultArray));
          setIsErrorResponse(false);
        } else {
          setErrorResponse(response.message);
          setIsErrorResponse(true);
        }
        setIsLoadingData(false);
      })
      .catch((error) => {
        setDataHeader([]);
        setIsLoadingData(false);
        setIsLoadingData(false);
        if (error.response) {
          setErrorResponse(error.response?.data?.state || error.response?.data?.mensaje);

          if (sessionDifference > Number(tokenExpired)) {
            sesionExpired(dispatch, history);
          }
        } else {
          setErrorResponse(error);
          actionErrorConnection(error);
        }
        setIsErrorResponse(true);
      });
  };

  /**
   * Suma los datos de toneladas y monto por cotejar
   * @param {*} recoverList array de consulta
   * @returns objeto con los dos números de la sumatoria
   */
  const SumDetailHeader = (recoverList) => {
    let amountAwardedSumTotal = 0;
    let tonTotal = 0;
    recoverList.forEach((m) => {
      if (m.invoicesThatOriginatedIt === "2"
        && (m.invoiceType === 'DZ' || m.invoiceType === 'DC' || m.invoiceType === 'DG' || m.invoiceType === 'DX')) {
        amountAwardedSumTotal += Number(m.amountAwardedSum);
        tonTotal += Number(m.ton);
      }
    });
    return { amountAwardedSumTotal, tonTotal };
  };

  const cellRender = (cell) => {
    //console.log('Cell: ', cell.column.id);
    if (cell.column.id === "an8") {
      if (cell.row.values?.total === "Total") {
        return " ";
      } else {
        return getValues().an8;
      }
    } else {
      if (cell.column.Header === "Monto por aplicar" || cell.column.Header === "Saldo Pendiente de aplicar sin IVA") {
        if (cell.row.values?.total === "Total") {
          return <b>{cell.column.Header === "Saldo Pendiente de aplicar sin IVA" ? "" : `$ ${parseFloat(cell.value).toLocaleString(currencySelected, { minimumFractionDigits: 2 })}`}</b>;
        } else {
          return `$ ${parseFloat(cell.value).toLocaleString(currencySelected, {
            minimumFractionDigits: 2,
          })}`;
        }
      } else if (cell.column.Header === "Ton.") {
        if (results.length > 0) {
          const rowId = cell.row.id;
          if (rowId < results.length) {
            //console.log('rowId: ', rowId, 'results[rowId]', results[rowId]);
            if (!(results[rowId].invoicesThatOriginatedIt === "2"
              && (results[rowId].invoiceType === 'DZ' || results[rowId].invoiceType === 'DC' || results[rowId].invoiceType === 'DG' || results[rowId].invoiceType === 'DX'))) {
              return " ";
            }
          }
        }

        if (cell.row.values?.total === "Total") {
          return (
            <b>
              {parseFloat(cell.value).toLocaleString(currencySelected, {
                minimumFractionDigits: 0,
              })}
            </b>
          );
        } else {
          return (
            <span>
              {parseFloat(cell.value).toLocaleString(currencySelected, {
                minimumFractionDigits: 0,
              })}
            </span>
          );
        }
      } else if (cell.column.Header === "Monto otorgado") {
        if (results.length > 0) {
          const rowId = cell.row.id;
          if (rowId < results.length) {
            //console.log('rowId: ', rowId, 'results[rowId]', results[rowId]);
            if (!(results[rowId].invoicesThatOriginatedIt === "2"
              && (results[rowId].invoiceType === 'DZ' || results[rowId].invoiceType === 'DC' || results[rowId].invoiceType === 'DG' || results[rowId].invoiceType === 'DX'))) {
              return " ";
            }
          }
        }

        if (cell.row.values?.total === "Total") {
          return <b>{`$ ${parseFloat(cell.value).toLocaleString(currencySelected, { minimumFractionDigits: 2 })}`}</b>;
        } else {
          return `$ ${parseFloat(cell.value).toLocaleString(currencySelected, {
            minimumFractionDigits: 2,
          })}`;
        }
      } else {
        return cell.render("Cell");
      }
    }
  };
  const getDownload = () =>{
    const params = getValues()
    const dataFileName = {
            an8: params.an8,
            startDate: selectStartDate ? selectStartDate : dateSubtract, //select the filter dates or the current day
            endDate: selectEndDate ? selectEndDate : dateSubtract
    }

    const headerParams = dataHeader[dataHeader.length -1]    
    const fileName = `bonificaciones_descuentos_header_${params.an8}_${dataFileName.startDate?.toLocaleDateString()}-${dataFileName.endDate?.toLocaleDateString()}`;
    const bodyContent = dataHeader.slice(0,-1) // separar  los valores totales del contenido de la tabla.
    setIsDownloadFile(true)
    DiscountsAndInvoicesServices.downloaddatDiscountsandInvoiceHeaderXlsx(bodyContent, dataFileName.an8, headerParams ).then((response)=>{

    const byteString = window.atob(response.split(',')[1]); //descodifica el contenido del archivo que se encuentra bas64 (contenido del archivo xlsx)
    const mimeString = response.split(',')[0].split(':')[1].split(';')[0]; //formato en el que se encuentra

    const ab = new ArrayBuffer(byteString.length); // buffer binario con la misma longitud de byteString
    const ia = new Uint8Array(ab); // nos permitira modificar el buffer binario de ab. 
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i) // a cada posicion de ia en i se le asignara el valor unicode en esa posicion
    }

    const dataBlob = new Blob([ab], { type: mimeString }); //AB tendrá todos los campos modificados por el for

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.xls`);
      setIsDownloadFile(false);
      return
    }

    const url = window.URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url
    link.setAttribute('download', `${fileName}.xls`);
    document.body.appendChild(link);
    link.click();
    link.remove(); // creamos un link para descargar el doc, posteriormente se elimina el link.
    setIsDownloadFile(false);
  },
  (error)=>{
    setIsDownloadFile(false);
    actionErrorConnection(error, 'Error al descargar archivo xls.');
  });
console.log('descargar archivo xls');

  }
  return (
    <>
      <div className="container-fluid p-0 m-0">
        <div className="row flex-nowrap p-0 m-0">
          <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
            <SidebarMenu />
          </div>
          <div className="col p-0 ms-1 me-1">
            <NavTopMenu />
            <div className="container ps-3 pe-3 container-size">
              <div className="row base-container ">
                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                  <span>Bonificaciones y Descuentos - Encabezado</span>
                </div>
                <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                  <div className="row ">
                    <div className="col-12 ">
                      <div className=" d-flex justify-content-end">
                        {customers.isLoading && (
                          <Tooltip title="Cargando filtro..." placement="top-start" arrow>
                            <div className="custom-icon-loading me-1">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>
                          </Tooltip>
                        )}
                        {
                          isDownloadFile ?
                          <Tooltip title="Descargargando..." placement="top-start" arrow>
                            <div className="custom-icon-loading me-1">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>
                          </Tooltip>
                            :
                          <Tooltip title="Descargar resultados" placement="top-start" arrow>
                            <div>
                              <button
                                className="btn custom-btn-icons"
                                onClick={()=>getDownload()}
                                type="button"
                                disabled={isLoadingData || isErrorResponse || dataHeader.length < 1}
                              >
                              <i className="fas fa-download"></i>
                              </button>
                            </div>
                          </Tooltip>
                        }
                        <Tooltip title="Filtrar" placement="top-start" arrow>
                          <button className="btn custom-btn-icons" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                            <i className="fas fa-filter"></i>
                          </button>
                        </Tooltip>
                      </div>
                      <div className="collapse show" id="collapseExample">
                        <div className="filter-continer">
                          <div className="container mt-3">
                            <form className="row">
                              <div className="col-12 mb-3">
                                <FormControl component="fieldset" className=" w-100 ">
                                  <FormLabel className="filterName" component="legend">
                                    Estado de facturas
                                  </FormLabel>
                                  <RadioGroup className="ms-md-12 ps-md-12 w-100" aria-label="invoice" name="invoice" row value={selectedStatusValue} onChange={handleChangeStatus}>
                                    <FormControlLabel value="" control={<CustomRadio />} label="Todos" />
                                    <FormControlLabel value="2" control={<CustomRadio />} label="Con saldo" />
                                  </RadioGroup>
                                </FormControl>
                              </div>
                              <div className="col-md-12 col-lg-12 mb-3">
                                <span className="filterName">Seleccionar Filtros</span>
                              </div>
                              <div className="col-md-5 col-lg-4 mb-3">
                                <TextField select id="an8" name="an8" label="Num. cliente*" variant="outlined" size="small" disabled={customers.isDisabled || customers.isLoading} fullWidth value={dataFilters.an8} {...register("an8")} onChange={(event) => handleChangeValue(event, "an8")}>
                                  <MenuItem value="">Seleccionar cliente</MenuItem>
                                  {customers.data.map(({ noCustomer, name }) => (
                                    <MenuItem key={noCustomer} value={noCustomer}>
                                      {noCustomer} - {name}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </div>
                              <div className="col-md-5 col-lg-4 mb-3">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                  <DatePicker disableToolbar autoOk fullWidth required control={control} id="startDate" name="startDate" inputVariant="outlined" variant="inline" label="Fecha de inicio" size="small" format="dd/LLLL/yyyy" value={selectStartDate} onChange={handleStartDateChange} />
                                </MuiPickersUtilsProvider>
                              </div>
                              <div className="col-md-5 col-lg-4 mb-3">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                  <DatePicker disableToolbar autoOk fullWidth required control={control} id="endDate" name="endDate" inputVariant="outlined" variant="inline" label="Fecha de Fin" size="small" format="dd/LLLL/yyyy" minDate={selectStartDate} minDateMessage="La fecha debe ser mayor a la de inicio" value={selectEndDate} onChange={handleEndDateChange} />
                                </MuiPickersUtilsProvider>
                              </div>
                              <div className="col-12 w-100 d-flex justify-content-end">
                                <Tooltip title={!selectStartDate || !selectEndDate ? "Completar filtros obligatorios" : "Buscar"} placement="top-start" arrow>
                                  <div>
                                    <button className="ms-2 mb-3 btn custom-btn" disabled={isLoadingData || !selectStartDate || !selectEndDate} onClick={handleSubmit(onSubmit)} type="submit" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                                      <i className="fas fa-search"></i>
                                    </button>
                                  </div>
                                </Tooltip>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <table className="" {...getTableProps()}>
                        <thead>
                          {headerGroups.map((headerGroup, i) => (
                            <tr {...headerGroup.getHeaderGroupProps()} className="element-header-content border-content " key={i}>
                              {headerGroup.headers.map((column, j) => (
                                <th {...column.getHeaderProps()} className="border-element header-element header-text pt-3 pb-3" key={j}>
                                  {column.render("Header")}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                          {rows.map((row) => {
                            prepareRow(row);
                            return (
                              <React.Fragment key={row.getRowProps().key}>
                                <tr className="element-row border-content">
                                  {row.cells.map((cell, i) => {
                                    return (
                                      <td className="border-element content-text padding-row-actions" key={i} {...cell.getCellProps()}>
                                        {cellRender(cell)}
                                      </td>
                                    );
                                  })}
                                </tr>
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                      {isErrorResponse && (
                        <div className="error-message border-content pt-4 pb-4">
                          <span className="">{errorResponse && errorResponse.toString()}</span>
                        </div>
                      )}
                      {isLoadingData && (
                        <div className=" border-content pt-4 pb-4 custom-icon-loading">
                          <i className="fas fa-spinner fa-spin"></i>
                        </div>
                      )}
                      {dataHeader.length === 0 && !isLoadingData && !isErrorResponse && isSubmitingData && (
                        <div className="element-row-message border-content pt-4 pb-4 ">
                          <span>Los filtros seleccionanos no devolvieron coincidencias.</span>
                        </div>
                      )}
                      {!isSubmitingData && !isLoadingData && !isErrorResponse && (
                        <div className="element-row-message border-content pt-4 pb-4">
                          <span>Ejecute una búsqueda para obtener resultados.</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

DiscountsAndInvoicesHeaderScreen.propTypes = {
  row: PropTypes.any,
  getToggleAllRowsSelectedProps: PropTypes.any,
  history: PropTypes.object,
  value: PropTypes.any,
};

